export default {
  Thinkers: 'NoteTypeThinkers',
  Document: 'NoteTypeDocument',
  Photo: 'NoteTypePhoto',
  Whiteboard: 'NoteTypeWhiteboard',
  Video: 'NoteTypeVideo',
  Audio: 'NoteTypeAudio',
  Text: 'NoteTypeText'
}